import actionTypes from '../constants/action-types';

const setCurrentColorPaletteVersion = (version) => ({
  type: actionTypes.SET_CURRENT_COLOR_PALETTE_VERSION,
  payload: {
    version,
  },
});

export default setCurrentColorPaletteVersion;
